






































  import { Component, Prop, Vue } from 'vue-property-decorator'
  import { namespace } from 'vuex-class'
  import { BindingHelpers } from 'vuex-class/lib/bindings'
  import cloneDeep from 'lodash/cloneDeep'
  import { Catalog } from '@one/types'

  const categories: BindingHelpers = namespace('categories')
  const products: BindingHelpers = namespace('products')
  const stocks: BindingHelpers = namespace('stocks')

  @Component({
    components: {
      OneCategoryTreeItem: () =>
        import('~/components/organisms/categoryTree/OneCategoryTreeItem.vue'),
    },
  })
  export default class OneCategoryTreeItem extends Vue {
    name: string = 'OneCategoryTreeItem'

    @categories.Action selectCategory: any
    @categories.Getter getCategory: any
    @categories.Getter getSelectedCategoryId: any

    @products.Getter getSortCriteria: any
    @products.Getter getCurrentPage: any
    @products.Getter getSearchedText: any
    @products.Getter getDefaultSortForCatalogBrowse: any
    @products.Getter getPerPage: any
    @products.Mutation('SET_PRICE') setPrice: any

    @stocks.Getter getDefaultWarehouseId: any
    @stocks.Getter getWarehouse: any

    @Prop({
      required: true,
      type: Array,
      default: () => [],
    })
    selectedCategoriesTree!: Array<string>

    @Prop({
      required: true,
      type: Object,
      default: () => ({}),
    })
    categoriesCount!: Record<string, number>

    @Prop({
      type: String,
      required: true,
    })
    categoryId!: string

    @Prop({
      type: String,
      required: false,
    })
    selectedCategoryId?: string

    @Prop({
      type: Number,
    })
    count?: number

    @Prop({
      type: String,
    })
    currentPriceParameter?: string

    @Prop({
      type: Boolean,
      required: false,
      default: false,
    })
    showEmptyCategories!: boolean

    @Prop({
      type: Boolean,
      default: true,
    })
    useAnchors!: boolean

    @Prop({
      type: Boolean,
      required: false,
      default: false,
    })
    onlySelected!: boolean

    @Prop({
      type: Boolean,
      required: false,
      default: false,
    })
    hydrationIdle!: boolean

    @Prop({
      type: String,
      required: false,
      default: '',
    })
    brandBasePath!: string

    isOpened: boolean = false
    isSearch = !this.showEmptyCategories

    composeHref() {
      const setFiltersQuery = () => {
        if (this.$route?.query?.filtersQuery) {
          return cloneDeep(this.$route.query.filtersQuery)
        }
      }
      const setSortWarehouse = () => {
        const sort = this.$route?.query?.sortCriteria ?? this.getSortCriteria

        if (sort === Catalog.WarehouseSortEnum.WAREHOUSE_STOCK_ASC || sort === Catalog.WarehouseSortEnum.WAREHOUSE_STOCK_DESC) {
          const warehouse = this.getWarehouse(this.getDefaultWarehouseId)
          return [warehouse.id, warehouse.parent].filter(Boolean)
        }

        return undefined
      }
      const params: any = {
        filtersQuery: setFiltersQuery(),
        page: 1,
        rows: this.getPerPage,
        sortCriteria: this.getSortCriteria,
        sortWarehouse: setSortWarehouse(),
      }
      if (this.currentPriceParameter) {
        params.price = this.currentPriceParameter
      }
      if (this.isSearch) {
        params.category = this.categoryId
        if (this.getSearchedText) {
          params.q = this.getSearchedText
        }
      }
      const simplifyUrl = () => {
        const defaultRows = 15
        const defaultSortCriteria = this.getDefaultSortForCatalogBrowse
        const { filtersQuery, price, page, rows, sortCriteria, sortWarehouse } = params
        return (
          !filtersQuery &&
          !price &&
          rows === defaultRows &&
          sortCriteria === defaultSortCriteria &&
          page === 1 &&
          !sortWarehouse
        )
      }

      if (this.brandBasePath && !this.isSearch) {
        const categoryPath = this.$routes.getCategoryPath(this.categoryId) || ''
        return this.$router.resolve({
          path: `${this.brandBasePath}${categoryPath}`,
          query: simplifyUrl() ? null : params,
        }).href
      }

      return this.$router.resolve({
        path: this.isSearch
          ? this.$route.path
          : this.$routes.getCategoryPath(this.categoryId) || this.$route.path,
        query: this.isSearch ? params : simplifyUrl() ? null : params,
      }).href
    }

    mounted() {
      this.isOpened = this.isSelected(this.categoryId)
    }

    get shouldShowCategory() {
      return (categoryId: string) => {
        if (this.showEmptyCategories) {
          if (!this.onlySelected) {
            return true
          }
          return this.isSelected(categoryId) || this.hasItems(categoryId)
        }
        return this.hasItems(categoryId)
      }
    }

    get isFolder() {
      return this.category.children.length
    }

    get category() {
      return this.getCategory(this.categoryId)
    }

    get getSelectedCategory() {
      return this.getCategory(this.selectedCategoryId)
    }

    get isSelected() {
      return (categoryId: string): boolean => {
        return this.selectedCategoriesTree && this.selectedCategoriesTree.includes(categoryId)
      }
    }

    onToggleFolder() {
      if (this.isFolder) {
        this.isOpened = !this.isOpened
      }
    }

    onCategorySelected(categoryId: string) {
      if (this.brandBasePath) {
        const categoryPath = this.$routes.getCategoryPath(categoryId)
        if (categoryPath) {
          this.$router.push(`${this.brandBasePath}${categoryPath}`)
        }
        return
      }
      if (categoryId !== this.selectedCategoryId) {
        this.$emit('category-selected', categoryId)
      }
    }

    onNameClick() {
      if (!this.useAnchors) {
        this.onCategorySelected(this.categoryId)
      }
    }

    get categoryCount() {
      return (categoryId: string) => {
        return this.categoriesCount[categoryId]
      }
    }

    hasItems(category: string) {
      return this.categoryCount(category) > 0
    }

    createTestId(categoryName: string): string | null {
      return this.hydrationIdle ? `catalog-list:categories-list:category-${categoryName}:li` : null
    }
  }
